import { createReducer } from 'redux-starter-kit';
import { loadLegalDocuments, saveLegalDocument } from './legalDocumentUiActions';
import { selectRequest } from '../../../domain/requests/RequestReducer';


/**
 * A Selector for the loadLegalDocuments request
 */
export const selectLoadLegalDocumentsRequest = (state) => {
  const requestId = state.via.ui.legalDocuments.loadLegalDocumentsRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A Selector for the saveLegalDocument request
 */
export const selectSaveLegalDocumentRequest = (state) => {
  const requestId = state.via.ui.legalDocuments.saveLegalDocumentRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

const initialLegalDocumentsState = {
  loadLegalDocumentsRequestId: null,
  saveLegalDocumentRequestId: null,
};

/**
 * A reducer for application configuration requests.
 */
const legalDocumentsUiReducer = createReducer(initialLegalDocumentsState, {

  [loadLegalDocuments]: (state, action) => ({
    ...state,
    loadLegalDocumentsRequestId: action.payload,
  }),

  [saveLegalDocument]: (state, action) => ({
    ...state,
    saveLegalDocumentRequestId: action.payload,
  }),
});

export default legalDocumentsUiReducer;
